import { evolve } from 'ramda';
import { parseStringDate } from 'common/dateFnsUtils';

export const subscription_plans = [
  'ADVANCED',
  'BASIC',
  'MEDIUM',
  'UNLIMITED',
] as const;

export type SubscriptionPlan = typeof subscription_plans[number];

export const partner_models = [
  'STANDARD',
  'DEMO',
  'HIGO_ONE',
  'RESELLER',
] as const;

export type PartnerModel = typeof partner_models[number];

export interface BusinessPartnerDataDTO {
  name: string;
  uniqueNumber: string;
  partnerType?: PartnerModel;
  partnerModel?: PartnerModel;
  description?: string;
  subscriptionConfig?: {
    subscriptionPlan: SubscriptionPlan;
    customExaminationsLimit: number | null;
    defaultExaminationsLimit: number | null;
  };
}

export interface BusinessPartnerDTO {
  createDate: string;
  id: number;
  name: string;
  uniqueNumber: string;
  partnerType?: PartnerModel;
  partnerModel?: PartnerModel;
  description?: string;
  numberOfDevices?: number;
  items?: object;
  parentPartnerId?: number;
  subaprtnerIds?: number[];
  subscriptionConfig?: {
    subscriptionPlan: SubscriptionPlan;
    customExaminationsLimit: number | null;
    defaultExaminationsLimit: number | null;
  };
}

export interface BusinessPartner {
  active?: boolean;
  createDate: Date;
  id: number;
  name: string;
  uniqueNumber: string;
  partnerType?: PartnerModel;
  partnerModel?: PartnerModel;
  description?: string;
  numberOfDevices?: number;
  parentPartnerId?: number;
  subaprtnerIds?: number[];
  subscriptionConfig?: {
    subscriptionPlan: SubscriptionPlan;
    customExaminationsLimit: number | null;
    defaultExaminationsLimit: number | null;
  };
}

export const mapToBusinessPartner = (
  dto: BusinessPartnerDTO
): BusinessPartner =>
  evolve(
    {
      createDate: parseStringDate,
    },
    dto
  );

export type BusinessPartnerCtx = BusinessPartner;
